module.exports = __webpack_public_path__ + "images/brand-id-c06ccd79566ee05ab73aea7bea48d495.svg";